'use strict';

module.exports = [
  '$log',
  '$document',
  '$sce',
  '$sanitize',
  ContenteditableDirective];

function ContenteditableDirective($log, $document, $sce, $sanitize) {
  return {
    restrict: 'A', // only activate on element attribute
    require: '?ngModel', // get a hold of NgModelController
    link: function (scope, element, attrs, ngModel) {
      if (!ngModel) return; // do nothing if no ng-model

      // Specify how UI should be updated
      ngModel.$render = function () {
        element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
      };

      ngModel.$parsers.push(replaceLineBreaks);
      ngModel.$formatters.push(normalizeLineBreaks);

      // Listen for change events to enable binding
      element.on('blur keyup change', function () {
        scope.$evalAsync(read);
      });

      element.on('paste', onPaste);

      read(); // initialize

      // Write data to the model
      function read() {
        var html = element.html();
        // When we clear the content editable the browser leaves a <br> behind
        // If strip-br attribute is provided then we strip this out
        if (attrs.stripBr && html == '<br>') {
          html = '';
        }
        ngModel.$setViewValue(html);
      }

      function replaceLineBreaks(html) {
        return html
          .replace(/<br(\s*)\/*>/ig, '\n')
          .replace(/<[p|div]\s/ig, '\n$0')
          .replace(/(<([^>]+)>)/ig, "")
          .replace(/&nbsp;/g, ' ');
      }

      function normalizeLineBreaks(text) {
        return $sanitize(text || '')
          .replace(/\\n/g, '<br>');
      }

      function replacePasteBreaks(text) {
        return (text || '')
          .replace(/\&#10;/g, '\n');
      }

      // TODO: this overwrites the entire text field. Need to insert text at cursor position or overwrite the selected text only
      function onPaste(e) {
        // cancel paste
        e.preventDefault();
        e.stopPropagation();
        var text, rep;

        //console.log('types', e.clipboardData.types);
        if (/text\/html/.test(e.clipboardData.types)) {
          //console.log('text/html');
          text = $sanitize(e.clipboardData.getData('text/html'));
          //console.log('text\n', text);
          rep = normalizeLineBreaks(replacePasteBreaks(replaceLineBreaks(text || '').replace(/\\n/g, '<br>')).trim());
          $log.debug('html-rep\n', rep);
        }
        else if (/text\/plain/.test(e.clipboardData.types)) {
          //console.log('text/plain');
          text = e.clipboardData.getData('text/plain');
          //console.log('text\n', text);
          rep = normalizeLineBreaks(replacePasteBreaks(text).trim());
          $log.debug('txt-rep\n', rep);
        }
        else {
          text = '';
        }

        $document[0].execCommand("insertHTML", false, rep);
        return false;
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/ContenteditableDirective.js